import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '../../../../services/toast.service';
import { TipoAnalise } from '../../../../types/TipoAnalise.type';
import { AnalisePesagemService } from './analisepesagem.service';

@Component({
  selector: 'app-analisepesagem-config',
  templateUrl: './analisepesagem.component.html',
  styleUrl: './analisepesagem.component.css'
})
export class AnalisePesagemConfigComponent implements OnInit {

  tiposAnalise: TipoAnalise[] = [];
  loading: boolean = true;

  instanciaSelecionada: string = localStorage.getItem('instancia') ?? '';

  displayDialog: boolean = false;
  editando: boolean = false;
  tipoAnaliseSelecionado: TipoAnalise = this.novoTipoAnalise();
  loadingSalvar: boolean = false;

  readonly codigosAnalise: string[] = ['DENSIDADE', 'TEMPERATURA', 'GRAU_INPM'];

  constructor(
    private analisePesagemService: AnalisePesagemService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.carregarTiposAnalise();
  }

  carregarTiposAnalise(): void {
    this.loading = true;
    this.analisePesagemService.findAll().subscribe({
      next: (data) => {
        this.tiposAnalise = data;
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao carregar tipos de análise: ' + (error?.error?.message ?? error.message));
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  getTiposAtivos(): number {
    return this.tiposAnalise.filter(t => t.ativo).length;
  }

  getTiposInativos(): number {
    return this.tiposAnalise.filter(t => !t.ativo).length;
  }

  novoTipoAnalise(): TipoAnalise {
    return {
      codigo: '',
      descricao: '',
      ativo: true
    };
  }

  abrirNovo(): void {
    this.tipoAnaliseSelecionado = this.novoTipoAnalise();
    this.tipoAnaliseSelecionado.instancia = this.instanciaSelecionada;
    this.editando = false;
    this.displayDialog = true;
  }

  abrirEditar(tipoAnalise: TipoAnalise): void {
    this.tipoAnaliseSelecionado = { ...tipoAnalise };
    this.editando = true;
    this.displayDialog = true;
  }

  fecharDialog(): void {
    this.displayDialog = false;
    this.tipoAnaliseSelecionado = this.novoTipoAnalise();
    this.loadingSalvar = false;
  }

  salvar(): void {
    if (!this.tipoAnaliseSelecionado.codigo) {
      this.toastService.erro('Validação', 'Preencha o campo obrigatório: Código.');
      return;
    }

    this.loadingSalvar = true;

    if (this.editando && this.tipoAnaliseSelecionado.id) {
      this.analisePesagemService.update(this.tipoAnaliseSelecionado.id, this.tipoAnaliseSelecionado).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Tipo de análise atualizado com sucesso');
          this.fecharDialog();
          this.carregarTiposAnalise();
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao atualizar tipo de análise: ' + (error?.error?.message ?? error.message));
          this.loadingSalvar = false;
        },
        complete: () => {
          this.loadingSalvar = false;
        }
      });
    } else {
      this.analisePesagemService.create(this.tipoAnaliseSelecionado).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Tipo de análise criado com sucesso');
          this.fecharDialog();
          this.carregarTiposAnalise();
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao criar tipo de análise: ' + (error?.error?.message ?? error.message));
          this.loadingSalvar = false;
        },
        complete: () => {
          this.loadingSalvar = false;
        }
      });
    }
  }

  confirmarExclusao(tipoAnalise: TipoAnalise, event: Event): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Deseja realmente excluir o tipo de análise "${tipoAnalise.codigo}"?`,
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.excluir(tipoAnalise);
      }
    });
  }

  excluir(tipoAnalise: TipoAnalise): void {
    if (!tipoAnalise.id) return;

    this.analisePesagemService.delete(tipoAnalise.id).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Tipo de análise excluído com sucesso');
        this.carregarTiposAnalise();
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao excluir tipo de análise: ' + (error?.error?.message ?? error.message));
      }
    });
  }

  get opcoesInstancia(): string[] {
    return [...new Set(this.tiposAnalise.map(t => t.instancia).filter(Boolean) as string[])].sort();
  }

}
